import Button from '@components/common/Button';
import CommonModal from '@components/common/CommonModal';
import InputFieldsComponent from '@components/common/InputFieldsSmall';
import { isValueContainsOnlyDigits } from '@utils/hrpConditionCheck';
import React, { useState } from 'react';
import { CHILD_ERROR_MESSAGES } from '../childConstants';
import { buttonNames } from '@constants/appConstants';

interface ChildAdhaarKYCModalProps {
  handleCloseModal: () => void;
  showChildAadhaarKycModal: any;
  handleModalBackButton: () => void;
  handleFinalProceed: (aadhaarNumber:any) => void;
  handleSkipKyc: () => void;
  flow: string;
}

const ChildAadhaarKYCModal: React.FC<ChildAdhaarKYCModalProps> = ({
  handleCloseModal,
  showChildAadhaarKycModal,
  handleModalBackButton,
  handleFinalProceed,
  handleSkipKyc,
  flow,
}) => {
  const [aadhaarNumber, setAadhaarNumber] = useState<string>('');
  const [isAadharNumberError, setIsAadharNumberError] = useState<boolean>(false);
  const [aadharNumberErrorMessage, setAadharNumberErrorMessage] = useState<string>('');

  const handleAadharChange = (event: any) => {
    const isValue = isValueContainsOnlyDigits(event);
    if (isValue) {
      setAadhaarNumber(event);
    } else if (event.length === 0) {
      setAadhaarNumber('');
    }
  };

  const handleSaveAdhar = (aadhaarNumber:any) => {
    let isError = false;
    if (aadhaarNumber.length !== 12) {
      setAadharNumberErrorMessage(CHILD_ERROR_MESSAGES.CHILD_AADHAR_NUMBER_ERROR,);
      setIsAadharNumberError(true);
      isError = true;
    } else {
      setIsAadharNumberError(false);
      isError = false;
    }
    if (!isError) {
      handleFinalProceed(aadhaarNumber);
    }
  };

  return (
    <CommonModal
      show={showChildAadhaarKycModal}
      handleClose={handleCloseModal}
      handleCustomBackButton={handleModalBackButton}
      conditionalClass="modal_component dynamic_form_field aadhar_kyc_modal"
      showCustomHeader={true}
      showButtonText={true}
      title=""
      size="md"
      footer={
        <>
          <div className="child-aadhar-submit">
            <Button
              onClick={() => handleSaveAdhar(aadhaarNumber)}
              disabled={aadhaarNumber.length !== 12}
              id="aadhar-beneficiary-submit"
              buttonName={buttonNames.CONTINUE}
              colorType={'primary'}
              icon={''}
              iconPosition={''}
            />
            {flow === 'create' && (
              <Button
                onClick={handleSkipKyc}
                disabled={false}
                id="aadhar-beneficiary-submit"
                buttonName={buttonNames.SKIP_KYC}
                colorType={'primary'}
                icon={''}
                iconPosition={''}
              />
            )}
          </div>
        </>
      }
    >
      <div>
        <div className="child_aadhar_container">
          <div className="aadhar_fields">
            <div className="child_aadhar_fields_container">
              <h1 className="aadhar_headings">Register with Aadhaar</h1>
              <InputFieldsComponent
                labelName="Enter Aadhaar Number"
                placeholder={'Type Here'}
                type={'text'}
                isDisabled={false}
                maximumLength={12}
                onChange={handleAadharChange}
                errorMessage={aadharNumberErrorMessage}
                inputType={isAadharNumberError ? 'error' : 'general'}
                value={aadhaarNumber}
                required={true}
              />
            </div>
          </div>
        </div>
      </div>
    </CommonModal>
  );
};

export default ChildAadhaarKYCModal;
